export const calculateComplianceRate = (diffDays, count) => {
  let complianceRate = parseFloat((count / ((Math.max(diffDays, 7) / 7) * 10) * 100).toFixed(2));
  return Math.min(complianceRate, 100);
}
